module.exports = __webpack_public_path__ + "static/media/4d6288e9-aecd-4870-ae09-89836aef511d.c1dca3b4.JPG";